
export const searchRequest = (searchValue,table,setList) => {
  const searchRegex = new RegExp(`.*${searchValue}.*`, "ig");
  const filteredRows = table.filter((o) => {
    return Object.keys(o).some((k) => {
      return searchRegex.test(o[k].toString());
    });
  });
  setList(filteredRows);
};
